import script from "./CandidateComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CandidateComponent.vue?vue&type=script&setup=true&lang=js"

import "./CandidateComponent.vue?vue&type=style&index=0&id=1917274a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1917274a"]])

export default __exports__